/**
 * @module ArticlesCarousel
 */
// eslint-disable-next-line no-unused-vars
import React from 'react';
import Carousel from '../Carousel/Carousel';
import { fetchMultipleArticlesByUUID } from '../../helpers/dataFetchers/findsFetchers';

/**
 * Represents a container to hold a carousel of articles.
 *
 * @param {object} props - The component props object.
 * @param {Array} props.articles - Array of articles uuid values.
 *
 * @returns {React.ReactElement} The ArticlesCarousel component.
 */
export default function RecommendedArticlesCarousel({ articles, ...props }) {
  const [data, setData] = React.useState([]);

  React.useEffect(() => {
    async function fetchData() {
      const articlesData = await fetchMultipleArticlesByUUID(articles);
      setData(articlesData);
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Carousel articles={data} isRecommendedArticlesCarousel={true} {...props} />
  );
}
